define('plugins/ractive/ractive.adaptor.backbone',[

    "lodash",
    "backbone"

], function (

    __,
    Backbone


) {

    var LOGLABEL = "r.adptr.bbn";


    var _fn = {
        is: {
            model: function (obj) {
                Backbone = Backbone || window.Backbone || null;

                if (!Backbone) {
                    throw("Missing Backbone Lib here.");
                    return;
                }

                return obj instanceof Backbone.Model;
            },
            collection: function (obj) {
                Backbone = Backbone || window.Backbone || null;

                if (!Backbone) {
                    throw("Missing Backbone Lib here.");
                    return;
                }

                return obj instanceof Backbone.Collection;
            }
        },
        wrapper: {
            model: function (ractive, mdl, keypath, prefixer) {
                var setChangeLock = 0,
                    setStatusLock = 0;

                var onChangeHandler =function (mdl0, options) {
                        if(options && options.viaRactive)
                            return;

                        try{
                            setChangeLock++;
                            if (__.size(mdl0.changed)) {
                                ractive.set(prefixer(mdl0.changed)).then(function(){
                                    setChangeLock--;
                                });

                            } else {
                                ractive.set(keypath, mdl0.toJSON()).then(function(){
                                    setChangeLock--;
                                });

                            }

                        }catch(err){
                            console.warn(LOGLABEL, err.message);
                        }

                    },
                    onStatusHandler = function(mdl0, newStatus, options){
                        if(options && options.viaRactive)
                            return;

                        var oldVal = ractive.get(keypath + ".status");

                        if(oldVal && oldVal !== newStatus){
                            setStatusLock++;
                            ractive.set(prefixer({status: newStatus})).then(function(){
                                setStatusLock--;
                            })
                        }

                    },
                    fn = {
                        reset: function (obj) {
                            if(setChangeLock) return;
                            if(_fn.is.model(obj) || !__.isObject(obj)) {
                                return false; // return false causes teardown
                            }

                            mdl.set(obj, {viaRactive: true});

                        },
                        set: function (keypath0, val) {
                            if(setChangeLock) return;

                            var keyElms = keypath0.split("."),
                                tmpKey,
                                valObj,
                                //depth = 0,
                                objPath = {};

                            valObj = objPath;

                            while (keyElms.length) {
                                tmpKey = keyElms.shift();

                                if (keyElms.length)
                                    objPath[tmpKey] = {};
                                else {
                                    objPath[tmpKey] = val;
                                }
                                objPath = objPath[tmpKey];
                            }

                            // if(origObj === val)
                            //     return;

                            //objPath[tmpKey] = val;

                            mdl.set(valObj, {viaRactive: true});

                        },
                        get: function() {
                            return mdl.toJSON();
                        },
                        teardown: function () {
                            mdl.off("change", onChangeHandler);
                            mdl.off("status", onStatusHandler);
                        }
                    };

                mdl.on("change", onChangeHandler);
                mdl.on("status", onStatusHandler);

                return fn;
            },
            collection: function (ractive, coll, keypath, prefixer) {
                var setLock;

                var onChangeHandler = function() {
                        var coll0, options;
                        switch(arguments.length){
                            case 3:
                                coll0 = arguments[1];
                                options = arguments[2];
                                break;
                            case 2:
                            case 1:
                                coll0 = arguments[0];
                                options = arguments[1];
                                break;
                        }

                        if(options && options.viaRactive)
                            return;

                        setLock = true;
                        ractive.set(keypath, coll0.toArray()).then(function(){  // TODO: smart collection update --ab
                            setLock = false;
                        });

                    },
                    fn = {
                        // set: function(){}, // not needed because either it is a reset for coll or it is a reset for a model
                        reset: function (arr) {
                            if(setLock) return;

                            if (_fn.is.collection(arr)
                                || !__.isArray(arr)
                                || (arr.length && _fn.is.model(arr[0]))) {
                                return false;  // return false causes teardown
                            }

                            coll.reset(arr, {viaRactive: true});
                        },
                        get: function () {
                            return coll.toArray();
                        },
                        teardown: function () {
                            coll.off("add remove reset sort", onChangeHandler);
                        }
                    };

                coll.on("add remove reset sort", onChangeHandler);

                return fn;
            }
        }
    };

    return {
        filter: function (obj) {
            return _fn.is.model(obj) || _fn.is.collection(obj);
        },
        wrap: function (ractive, obj, keypath, prefixer) {

            if (_fn.is.model(obj)) {
                return _fn.wrapper.model(ractive, obj, keypath, prefixer);
            } else if (_fn.is.collection(obj)) {
                return _fn.wrapper.collection(ractive, obj, keypath, prefixer);
            }

        }
    };

});
